
<mat-spinner class="spinner" *ngIf="loading"
></mat-spinner>
<!-- thank-you section start -->

<section class="light-layout" *ngIf="!loading">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="success-text">
                    <i class="fa fa-check-circle" aria-hidden="true"></i>
                    <h2>¡{{'success.thankyou' | translate}}!</h2>
                    <p>{{'success.orderSuccefully' | translate}}</p>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- Section ends -->

<!-- order-detail section start -->
<section class="detailOrder" *ngIf="!loading">  
    <div class="container">
        <mat-card class="margin-card">
        <h3 class="title-invoice"><b>{{'success.orderdetail' | translate}}</b></h3>
        <div class="row">
            <div class="col-md-8">
                <div class="product-order">
                    <div class="row row-tittle" >
                        <div class="col-4 col-md-6 order_detail"><h4>{{'cart-table.product-name' | translate}}</h4></div>
                        <div class="col-4 col-md-3 order_detail"><h4>{{'cart-table.quantity' | translate}}</h4></div>
                        <div class="col-4 col-md-3 order_detail"><h4>{{'cart-table.price' | translate}}</h4></div>
                    </div>
                    <div class="row-border"></div>
                    <div class="row row-detail-product" *ngFor="let basketItem of basketOrder.items">
                        <div class="col-6 order_detail">
                            <p>{{articleService.getArticleName(basketItem.item)}}</p>
                        </div>
                        <div class="col-3 order_detail">
                            <p class="cantidad">{{basketItem.quantity}}</p>
                        </div>
                        <div class="col-3 order_detail">
                            <p>{{ articleService.getPriceToShow(basketItem.unitPrice) | currency:productsService?.currency:'symbol'}}</p>
                        </div>
                    </div>
                   <!--<div class="row">                        
                        <div class="offset-6 col-3 order_detail row-tittle margen-top"><h4>{{'cart-table.subtotal' | translate}}</h4></div>
                        <div class="col-3 order_detail margen-top"><p>{{totalOrder | currency:productsService?.currency:'symbol'}}</p></div>
                    </div>-->
                    <div class="row hidden-xs">                        
                        <div class="offset-6 col-3 order_detail row-tittle margen-top"><h4>{{'cart-table.total' | translate}}</h4></div>
                        <div class="col-3 order_detail margen-top"><p>{{totalOrder | currency:productsService?.currency:'symbol'}}</p></div>
                    </div>
                </div>
            </div>
            <div class="col-md-4 second-column">
                <div class="row row-sumary-total-title">
                    <div class="col-md-12">
                        <h4 class="row-title">{{'cart-table.total' | translate}}</h4>
                    </div>
                </div>
                <div class="row row-sumary-total">
                    <div class="col-md-12">
                        <span>{{totalOrder | currency:productsService?.currency:'symbol'}}</span>
                    </div>
                </div>
                <div class="row-border-total"></div>
                <div class="row text-right">
                    <div class="col-md-12">
                        <h4 class="row-sumary-total-title margen-top">{{'cart-table.billed-to' | translate}}</h4>
                    </div>
                </div>
                <div class="row text-right">
                    <div class="col-md-12">
                        <p class="resumen-compra" *ngIf="basketOrder.customerDelivery.name" >{{ basketOrder.customerDelivery.name }}</p>
                        <p class="resumen-compra" *ngIf="basketOrder.customerDelivery.lastName" >{{ basketOrder.customerDelivery.lastName }}</p>
                        <p class="resumen-compra" *ngIf="basketOrder.customerDelivery.cellphone" >{{ basketOrder.customerDelivery.cellphone }}</p>
                        <p class="resumen-compra" *ngIf="basketOrder.customerDelivery.address" >{{ basketOrder.customerDelivery.address }}</p>
                        <p class="resumen-compra" *ngIf="basketOrder.customerDelivery.city" >{{ basketOrder.customerDelivery.city }}</p>
                        <p class="resumen-compra" *ngIf="basketOrder.customerDelivery.zipCode" >{{ basketOrder.customerDelivery.zipCode }}</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h4 class="row-sumary-total-title">{{'success.ordernro' | translate}}</h4>
                        <p>{{ basketOrder.id }}</p>
                    </div>
                </div>
                <div class="margen-top">
                    <div>
                        <h4 class="row-sumary-total-title">{{'success.orderdate' | translate}}</h4>
                        <p>{{ basketOrder.open | date: 'dd/MM/yyyy' }}</p>
                    </div>
                </div>
                <div class="order-success-sec margen-top">
                    <div>
                        <button  [routerLink]="['/']" mat-raised-button color="primary" class="btn-detalle">{{'back' | translate}}</button>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
    </div>
</section>

<!-- Section ends -->
